export const parseCollections = (allCollectionsJson) => {
  return (allCollectionsJson.edges || allCollectionsJson).map((x) =>
    parseCollection(x.node || x)
  )
}

export const parseNewsList = (list) => {
  return list.map((x) => ({
    id: x.id,
    type: x.type,
    title: x.attributes.title,
    date: x.attributes["published-at"],
  }))
}

export const parseCollection = (node) => {
  return {
    id: node.id,
    title: node.title,
    desc: node.desc,
    image: node.cover?.publicURL,
    series: node.series,
    slug: node.slug,
    imgs: node.imgs?.map((x) => x?.publicURL).filter((x) => x),
  }
}
